const SITE_NAME = 'Dynopia';

export default {
  url: 'http://www.dynopia.com',
  name: SITE_NAME,
  meta: {
    facebook: {
      appId: '164671430217010',
      userId: '1034430124',
      siteName: SITE_NAME,
    },
    twitter: {
      handle: '@dynopia',
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/data/site/index.js